import { User } from '../../user/user.model';
import { TemplateVersionShallow } from '../core';

export interface MainState {
    pending: {
        reload?: boolean;
    };

    templateVersions?: TemplateVersionShallow[];
    didInitialLoad?: boolean;

    /** as an object so that all changes are observable, even when the value is the same */
    selectedUser?: {
        value?: User;
        initialLoad?: boolean;
    };

    /** as an object so that all changes are observable, even when the value is the same */
    selectedTemplateVersionId?: {
        value?: number;
        initialLoad?: boolean;
    };
}

export const defaultState = (): MainState => ({
    pending: {},
});
